import React from 'react';
import PropTypes from 'prop-types';
import {fromJS, List, Map} from 'immutable';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import appConfig from '../../appConfig';
import PanelTree from '../PanelTree';
import { showExternalAsMain } from '../../actions/mainUI';
import { createTemplateURL } from '../../utils/piction';
import { getLabelFromAppConfig } from '../../utils/uiUtils';
import { validateSessionConnection } from '../../actions/session';
import DocIcon from '../Icons/DocDefault';

const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = dispatch => ({
  dispatch: actionToDispatch => dispatch(actionToDispatch),
  validateSession: surl => dispatch(validateSessionConnection(surl)),
});

const NavFormsPanel = ({ dispatch, intl, session, validateSession }) => {
  let optionsList;

  if (appConfig.menuOptions &&
    appConfig.menuOptions.formsMenu &&
    appConfig.menuOptions.formsMenu.options) {
    optionsList = fromJS(Object.keys(appConfig.menuOptions.formsMenu.options).map(
      key => ({
        i: key,
        n: getLabelFromAppConfig(appConfig.menuOptions.formsMenu.options[key], intl.locale),
      })
    ));
  } else optionsList = new List();

  const onPanelItemClick = (key) => {
    const surl = session ? session.get('surl') : sessionStorage.surl;
    validateSession(surl).then((res) => {
      if (res.isValid) {
        const templateURL = appConfig.menuOptions.formsMenu.options[key].name;
        if (templateURL) {
          dispatch(showExternalAsMain(
            createTemplateURL(templateURL, undefined, intl.locale),
            surl));
        }
      }
    });
  };

  return (
    <div className="nav-content__body">
      <h2 className="nav-content__title">{intl.formatMessage({ id: 'navFormsPanel.formHeader' })}</h2>
      <PanelTree
        onPanelItemClick={onPanelItemClick}
        panelTreeList={optionsList}
        isRoot
        icon={<DocIcon style={{margin: '0 6px'}} />}
      />
    </div>
  );
};

NavFormsPanel.propTypes = {
  dispatch: PropTypes.func,
  session: PropTypes.instanceOf(Map),
  validateSession: PropTypes.func,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(NavFormsPanel));
